import React from 'react';

export default function AuthenticatingModal({ isOpen }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-[200] flex items-center justify-center">
      <div className="bg-[#0D1A27] border border-[#273C61] p-6 rounded-lg w-[400px]">
        <div className="flex items-center mb-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#FF7800] mr-3"></div>
          <h3 className="text-lg font-semibold text-white">Authenticating...</h3>
        </div>
        <p className="text-white/70 mb-4">Please accept using the popup.</p>
        <div className="bg-[#111e2e] border border-[#273C61] rounded-lg p-3">
          <p className="text-sm text-white/60">
            If no popup appears, please reload the page and make sure you have allowed popups in your browser.
          </p>
        </div>
      </div>
    </div>
  );
}